import { IsNotEmpty, IsUUID } from 'class-validator';

export class DefineCentralEventCommand {
  @IsNotEmpty()
  @IsUUID()
  id: string;
}
